// extracted by mini-css-extract-plugin
export var animationContainer = "_jl-0";
export var footer = "_jl-1";
export var gray = "_jl-2";
export var lineItem = "_jl-3";
export var lineItemImage = "_jl-4";
export var lineItemInfo = "_jl-5";
export var lineItemText = "_jl-6";
export var lineItems = "_jl-7";
export var modalContent = "_jl-8";
export var options = "_jl-9";
export var orderName = "_jl-a";
export var refundAmount = "_jl-b";